__turbopack_context__.v({
  "hero": "patientHero-module-scss-module__SZt78W__hero",
  "heroBox": "patientHero-module-scss-module__SZt78W__heroBox",
  "heroButton": "patientHero-module-scss-module__SZt78W__heroButton",
  "heroContent": "patientHero-module-scss-module__SZt78W__heroContent",
  "heroImageBigDesktop": "patientHero-module-scss-module__SZt78W__heroImageBigDesktop",
  "heroImageDesktop": "patientHero-module-scss-module__SZt78W__heroImageDesktop",
  "heroImagePhone": "patientHero-module-scss-module__SZt78W__heroImagePhone",
  "heroImageTablet": "patientHero-module-scss-module__SZt78W__heroImageTablet",
  "heroTextAlign": "patientHero-module-scss-module__SZt78W__heroTextAlign",
  "heroTitle": "patientHero-module-scss-module__SZt78W__heroTitle",
  "heroUlBlock": "patientHero-module-scss-module__SZt78W__heroUlBlock",
  "heroUlListItem": "patientHero-module-scss-module__SZt78W__heroUlListItem",
  "threeLineEllipse": "patientHero-module-scss-module__SZt78W__threeLineEllipse",
});
